import { createModel } from 'xstate/lib/model';

import { CompanyContextType } from 'common/hooks/useCompanyContext/types';
import baseEvents from 'features/Bento/libs/machines/config/baseEvents';

import { ApplicationTypeContextType } from '../../../lib/applicationType';
import { ShineStartDataQuery } from '../graphql/queries/shineStartData.gql';

type OnboardingShineStartModuleData = {
  companyContext: CompanyContextType;
  applicationTypeContext: ApplicationTypeContextType;
  /**
   * We have to remap company to make it optional
   * @see https://github.com/dotansimha/graphql-code-generator/issues/8461
   */
  data: Omit<ShineStartDataQuery, 'viewer'> & {
    viewer: Omit<ShineStartDataQuery['viewer'], 'company'> & {
      company: ShineStartDataQuery['viewer']['company'] | null;
    };
  };
};

const context = {
  getModuleData: (() => {
    throw new Error('NOT_IMPLEMENTED');
  }) as () => OnboardingShineStartModuleData,
};

export type Context = typeof context;

const model = createModel(
  context,

  {
    events: {
      ...baseEvents,
      BUSINESS_INFO_REFUSED: () => ({}),
      DOWNLOAD_SHINE: () => ({}),
    },
  },
);

export default model;

export type Model = typeof model;
